import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/home';
import AboutUs from './pages/aboutUs';
import WhyUs from './pages/whyUs';
import OurServices from './pages/ourServices';
import ServiceDetail from './pages/serviceDetail';
import Gallery from './pages/gallery';
import Clients from './pages/clients';
import ClientStories from './pages/clientStories';
import Contact from './pages/contact';
import Admin from './pages/admin';
import { getFirestore, updateDoc } from 'firebase/firestore';
import { firebaseApp } from './utils/firebase';
import { collection, getDocs, doc } from 'firebase/firestore';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { AnimatePresence } from 'framer-motion';

function App() {
	const [visitedData, setVisitedData] = useState({});
	const location = useLocation();

	useEffect(() => {
		const fetchPageViewCount = async () => {
			try {
				console.log('DEBUG: Starting fetchPageViewCount');
				const db = getFirestore();
				console.log('DEBUG: Firestore instance obtained');
				
				const visitedRef = collection(db, 'visited');
				console.log('DEBUG: Collection reference created');
				
				const response = await getDocs(visitedRef);
				console.log('DEBUG: Firestore response received. Empty:', response.empty);
				
				if (!response.empty) {
					const firstDoc = response.docs[0];
					console.log('DEBUG: Document found ID:', firstDoc.id);
					console.log('DEBUG: Document data:', firstDoc.data());
					
					const data = {
						count: firstDoc.data().count,
						eventCount: firstDoc.data().event_count || 0,
						id: firstDoc.id,
					};
					setVisitedData(data);
					console.log('DEBUG: State updated with data:', data);

					// Only increment once per session to save on Firestore writes
					const hasVisited = sessionStorage.getItem('hasVisited');
					console.log('DEBUG: sessionStorage hasVisited:', hasVisited);
					
					if (!hasVisited) {
						console.log('DEBUG: Incrementing count in Firestore...');
						const docRef = doc(db, 'visited', data.id);
						await updateDoc(docRef, { count: data.count + 1 });
						sessionStorage.setItem('hasVisited', 'true');
						console.log('DEBUG: Welcome - Visitor count updated successfully');
					} else {
						console.log('DEBUG: Skipping increment (already visited in this session)');
					}
				} else {
					console.warn('DEBUG: No "visited" collection or document found in Firestore.');
				}

				const analytics = getAnalytics(firebaseApp);
				logEvent(analytics, 'page_view', { page_title: 'home' });
			} catch (error) {
				console.error('--- DEBUG FIREBASE ERROR ---');
				console.error('Code:', error.code);
				console.error('Message:', error.message);
				console.error('Full Error:', error);
			}
		};

		fetchPageViewCount();
	}, []);

	return (
		<>
			<Navbar visitedCount={visitedData.count} />
			<AnimatePresence mode='wait'>
				<Routes location={location} key={location.pathname}>
					<Route path='/' exact element={<Home eventCount={visitedData.eventCount} />} />
					<Route path='/about_us' element={<AboutUs />} />
					<Route path='/why_us' element={<WhyUs />} />
					<Route path='/our_services' element={<OurServices />} />
					<Route path='/our_services/:serviceId' element={<ServiceDetail />} />
					<Route path='/gallery' element={<Gallery />} />
					<Route path='/clients' element={<Clients />} />
					<Route path='/stories' element={<ClientStories />} />
					<Route path='/contact' element={<Contact />} />
					<Route path='/admin' element={<Admin />} />
				</Routes>
			</AnimatePresence>
		</>
	);
}

export default App;
